import React, { useEffect, useState } from "react";

import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Avatar,
  useTheme,
  Button,
  IconButton,
  Stack,
  Grow,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from "@mui/material";
import Chart from "react-apexcharts";
import {
  dataGridHeight,
  dataGridHeaderFooterHeight,
  formGap,
  dataGridRowHeight,
} from "../../ui-components/global/utils";
import { DataGrid } from "@mui/x-data-grid";
import WorkIcon from "@mui/icons-material/Work";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import LoopIcon from "@mui/icons-material/Loop";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { CalendarToday } from "@mui/icons-material";
import { Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import Datavisual1 from "./Calendar";
import { DashcalpostData } from "../../store/reducers/Formapireducer";
import { useDispatch, useSelector } from "react-redux";
import DashboardIcon from "@mui/icons-material/Dashboard";
import {
  dashBoardAtten,
  EmployeeEffort,
} from "../../store/reducers/LoginReducer";
import { useNavigate, useParams } from "react-router-dom";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { tokens } from "../../Theme";
import PersonIcon from "@mui/icons-material/Person";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { fetchListview } from "../../store/reducers/Listviewapireducer";
const ManagerDashBoardScrum = () => {
  const dispatch = useDispatch();
  const empID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");
   const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");

  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");
const companyClassification = sessionStorage.getItem("Classification");
console.log(companyClassification, "-companyClassification");

    const CompanySignature = sessionStorage.getItem("CompanySignature");
    console.log("🚀 ~ EmployeeDashboard ~ CompanySignature:", CompanySignature)

    const ManagerEmpIDCS = sessionStorage.getItem("ManagerEmpIDCS");
    const EMP_TRAINBY = sessionStorage.getItem("EMP_TRAINBY");
  console.log("🚀 ~ ManagerDashBoard ~ ManagerEmpIDCS:", ManagerEmpIDCS)
  const [pageSize, setPageSize] = useState(31);
  const [rowCount, setRowCount] = useState(0);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const [isCalender, setIsCalender] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [weelyShow, setWeeklyShow] = useState("W");
  const [attendanceShow, setAttendanceShow] = useState("Y");
  const navigate = useNavigate();
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const params = useParams();
  console.log(params,"--Passing Params");
//   useEffect(() => {
//   console.log("Effect Triggered");
//   console.log("Type:", params?.Type);
//   console.log("empID:", empID);

//   if (!params?.Type || !empID) {
//     console.log("Skipped API call");
//     return;
//   }

//   dispatch(
//     dashBoardAtten({
//       data: {
//         EmployeeID: empID,
//         Type: params.Type,
//       },
//     })
//   );
// }, [params?.Type, empID]);
  useEffect(() => {
    console.log( "--caling MGRDSHBSCRUM");
    
    dispatch(
      dashBoardAtten({ data: { EmployeeID: empID, Type: params.Type } })
    );
  }, []);
  const [isColor, setIsColor] = useState("C");
  // const summaryData = [
  //   {
  //     title: "Backlog Tasks - (18)",
  //     count: 18,
  //     gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
  //     icon: <HourglassTopIcon />,
  //     breakdown: ["Self (4)", "Manager (8)", "Sprint (6)"],
  //   },

  //   {
  //     title: "To do Tasks",
  //     count: 12,
  //     gradient: "linear-gradient(135deg, #17ead9, #6078ea)",
  //     icon: <LoopIcon />,
  //     breakdown: ["Self (4)", "Manager (6)", "Sprint (2)"],
  //   },

  //   {
  //     title: "Completed Tasks",
  //     count: 15,
  //     gradient: "linear-gradient(135deg, #42e695, #3bb2b8)",
  //     icon: <DoneAllIcon />,
  //     breakdown: ["Self (4)", "Manager (8)", "Sprint (3)"],
  //   },
  //   {
  //     title: "Total Tasks",
  //     count: 45,
  //     gradient: "linear-gradient(135deg, #ff6a00, #ee0979)",
  //     icon: <WorkIcon />,
  //     subtitle: "Approved Task: 55",
  //     breakdown: ["SPA (4)", "Approved (55)", "Blocked (3)"], // 👈 Add this line
  //   },
  // ];
  const summaryData = [
    {
      title: "Backlog Tasks",
      count: 18,
      gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
      icon: <HourglassTopIcon />,
      breakdown: ["Self (4)", "Manager (6)", "Sprint (2)"],
      breakdownFilters: {
        Self: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Self'AND CompanyID='${compID}'`,
        Manager: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Manager'`,
        Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Sprint'`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('SH','AS') AND CompanyID='${compID}'`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
    {
      title: "To do Tasks",
      count: 12,
      gradient: "linear-gradient(135deg, #17ead9, #6078ea)",
      icon: <LoopIcon />,
      breakdown: ["Self (4)", "Manager (6)", "Sprint (2)"],
      breakdownFilters: {
        Self: `EmployeesID='${empID}' AND FilterStatus IN ('I') AND TaskSource = 'Self'`,
        Manager: `EmployeesID='${empID}' AND FilterStatus IN ('I') AND TaskSource = 'Manager'`,
        Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('I') AND TaskSource = 'Sprint'`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('I')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
    {
      title: "Completed Tasks",
      count: 15,
      gradient: "linear-gradient(135deg, #42e695, #3bb2b8)",
      icon: <DoneAllIcon />,
      breakdown: ["Self (4)", "Manager (8)", "Sprint (3)"],
      breakdownFilters: {
        Self: `EmployeesID='${empID}' AND FilterStatus IN ('C') AND TaskSource = 'Self'`,
        Manager: `EmployeesID='${empID}' AND FilterStatus IN ('C') AND TaskSource = 'Manager'`,
        Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('C') AND TaskSource = 'Sprint'`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('C')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
    {
      title: "Total Tasks",
      count: 45,
      gradient: "linear-gradient(135deg, #ff6a00, #ee0979)",
      icon: <WorkIcon />,
      subtitle: "Approved Task: 55",
      breakdown: ["SPA (4)", "Approved (55)", "Blocked (3)"],
      breakdownFilters: {
        SPA: `EmployeesID='${empID}' AND TaskSource = 'SpotActivity'`,
        Approved: `EmployeesID='${empID}' AND FilterStatus IN ('AP')`,
        Blocked: `EmployeesID='${empID}' AND FilterStatus IN ('B')`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('AP','B')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
  ];
  const handleCardClick = (item) => {
    // dispatch API call with that card's query
    dispatch(
      fetchListview(
        item.query.AccessID,
        item.query.ScreenName,
        item.query.Filter,
        item.query.Any,
        item.query.CompId
        // item.query.Type
      )
    );
    // navigate to the route
    navigate(item.path);
  };
  const handleBreakdownClick = (filter) => {
    const AccessID = "TR277";
    const ScreenName = "Scrum Task";
    const Any = "";
    const CompId = compID;

    dispatch(fetchListview(AccessID, ScreenName, filter, Any, CompId));

    navigate("/Apps/TR277/Scrum%20Task");
  };
  // const breakdownFilters = {
  //   Self: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Self'`,
  //   Manager: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Manager'`,
  //   Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Sprint'`,
  //   // SPA:  `EmployeesID='${empID}' AND TaskSource = 'SPA'`,
  //   // Approved: `EmployeesID='${empID}' AND FilterStatus IN ('AP','BL') AND TaskSource = 'Approved'`,
  //   // Blocked: `EmployeesID='${empID}' AND FilterStatus IN ('AP','BL') AND TaskSource = 'Blocked'`
  // };

  const chartOptions = {
    chart: { type: "bar", stacked: false, toolbar: { show: false } },
    colors: ["#e91e63", "#ff9800", "#4caf50", "#00695F", "#1976d2"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 4,
        distributed: true,
      },
    },
    xaxis: {
      // categories: ["Total", "To do", "Backlog", "Completed"],
      categories: ["Backlog", "To do", "Completed", "Approved", "Total"],
    },
    dataLabels: { enabled: false },
    legend: { position: "bottom" },
  };

  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Projects</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  function EmployeeTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>List of Employees Effort</Typography> */}
          <Typography>
            List of Personnel Effort{" "}
            {selectedProject?.P_DESC ? `(${selectedProject.P_DESC})` : ""}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  const [selectedProject, setSelectedProject] = useState(null);
  const [employeeRows, setEmployeeRows] = useState([]);

  const ProjectColumn = [
    {
      field: "slno",
      headerName: "SL#",
      width: 50,
      sortable: false,
      filterable: false,
      valueGetter: (params) =>
        `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    },

    {
      field: "P_DESC",
      headerName: "Project",
      width: 250,
      headerAlign: "center",
    },
  ];
  const EmployeeColumn = [
    {
      field: "slno",
      headerName: "SL#",
      width: 50,
      sortable: false,
      filterable: false,
      valueGetter: (params) =>
        `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    },
    {
      field: "EmployeeName",
      headerName: "Personnel",
      width: 200,
      headerAlign: "center",
    },
    {
      field: "ScheduledHours",
      headerName: "Est Hrs",
      width: 60,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "ActualHours",
      headerName: "Act Hrs",
      width: 60,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "EstimateCosting",
      field: "EstimateCosting",
      headerName: "Est Hrs Cost",
      width: 90,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "ActualCosting",
      headerName: "Act Hrs Cost",
      width: 90,
      headerAlign: "center",
      align: "right",
    },
  ];

  const dashBoardAttenGetData = useSelector(
    (state) => state.loginApi.dashBoardAttenGetData
  );
  console.log(dashBoardAttenGetData, "--dashBoardAttenGetData");
  
const tabledatarows =
  dashBoardAttenGetData?.projectTaskData?.leaveDetailsData?.tableData || [];
  console.log(tabledatarows, "--tabledatarows");
                        
  const dashBoardAttenGetStaus = useSelector(
    (state) => state.loginApi.dashBoardAttenGetStaus
  );
  const dashBoardAttenGetLoading = useSelector(
    (state) => state.loginApi.dashBoardAttenGetLoading
  );
  const dashBoardAttenGetError = useSelector(
    (state) => state.loginApi.dashBoardAttenGetError
  );

  const empEffortGetData = useSelector(
    (state) => state.loginApi.empEffortGetData
  );
  const empEffortGetLoading = useSelector(
    (state) => state.loginApi.empEffortGetLoading
  );

  const pieData = {
    series:
      isColor == "C"
        ? dashBoardAttenGetData?.agingData?.completedData
        : isColor == "B"
          ? dashBoardAttenGetData?.agingData?.backlogData
          : dashBoardAttenGetData?.agingData?.todoData,
    options: {
      labels: ["Today", "This Week", ">1 Week"],
      chart: { type: "donut" },
      legend: { position: "bottom" },
      colors:
        isColor == "C"
          ? ["#00695f", "#009688", "#33ab9f"]
          : isColor == "B"
            ? ["#aa2e25", "#f44336", "#f6685e"]
            : ["#2c387e", "#3f51b5", "#6573c3"],
    },
  };

  const projectTaskDat4 = {
    xaxis: ["ESS", "LGEMS"],
    yaxis: [
      {
        name: "Ahead",
        data: [40, 0],
      },
      {
        name: "Late",
        data: [0, -30],
      },
    ],
  };

  const projectTaskData = {
    xaxis: ["ESS", "LGEMS", "UAAM"],
    yaxis: [
      {
        name: "Total Hours",
        data: [1050, 551, 70],
      },
      {
        name: "Scheduled Asap Today",
        data: [449, 285, 51],
      },
      {
        name: "Actual Hours",
        data: [185, 70, 5],
      },
    ],
  };

  const series = [
    {
      name: "Baclog",
      data: [1, 5, 9, 13],
    },
    {
      name: "In Progress",
      data: [0, 2, 5, 7],
    },
    {
      name: "Completed",
      data: [0, 0, 3, 4],
    },
    {
      name: "Approved",
      data: [0, 0, 1, 3],
    },
  ];

  return (
    <Box p={3} sx={{ background: "#FFFFFF" }}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {/* PROJECT MANAGER DASHBOARD */}
         { companyClassification === "Board Of Directors" ? "PRINCIPAL DASHBOARD"
         : companyClassification === "Staff" ? "STAFF DASHBOARD" : 
         companyClassification === "Intern" ? "STUDENT DASHBOARD" : "PROJECT MANAGER DASHBOARD"}
        </Typography>
        <Stack direction={"row"} gap={2}>
          {is003Subscription && isprojectmanager == "Y" && (
            <>
              <Tooltip title="Staff Calendar">
                <IconButton
                  onClick={() => {
                    navigate("/Apps/Teacher-dashbord/T");
                    dispatch(
                      dashBoardAtten({ data: { EmployeeID: empID, Type: "T" } })
                    );
                  }}
                  color="primary"
                >
                  <RecentActorsIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Class Calendar">
                <IconButton
                  onClick={() => {
                    navigate("/Apps/ClassCalendar-dashbord/C");
                    dispatch(
                      dashBoardAtten({ data: { EmployeeID: empID, Type: "T" } })
                    );
                  }}
                  color="primary"
                >
                  <RecentActorsIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          <Tooltip title="Personnel Dashboard">
            <IconButton
              onClick={() => {
                navigate("/Apps/dashbord/E");
                dispatch(
                  dashBoardAtten({ data: { EmployeeID: empID, Type: "E" } })
                );
              }}
              color="primary"
            >
              <RecentActorsIcon />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={isCalender ? "Project Manager Dashboard" : "Task Calendar"}
          >
            <IconButton
              onClick={() => setIsCalender(!isCalender)}
              color="primary"
            // title="D"
            >
              {isCalender ? <DashboardIcon /> : <CalendarToday />}
            </IconButton>
          </Tooltip>


        </Stack>
      </Stack>

      {!isCalender ? (
        <React.Fragment>
          <Grid container spacing={3}>
            {/* {dashBoardAttenGetData.taskSummaryCardData.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    background: item.gradient,
                    color: "#fff",
                    height: 150,
                    borderRadius: 3,
                    boxShadow: 4,
                  }}
                >
                  <CardContent
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {item.title}
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                          {item.count}
                        </Typography>
                      </Box>
                      <Avatar sx={{ bgcolor: "white", color: "#000" }}>
                        {summaryData[index]["icon"]}
                      </Avatar>
                    </Box>

                    {item.breakdown && (
                      <Box mt={1}>
                        {item.breakdown.map((b, i) => (
                          <Typography
                            key={i}
                            ml={0.5}
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              mt: 0.5,
                              px: 1,
                              py: 0.3,
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                              borderRadius: 1,
                              display: "inline-block",
                            }}
                          >
                            • {b}
                          </Typography>
                        ))}
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))} */}
            {dashBoardAttenGetData?.taskSummaryCardData?.map((item, index) => {
              // merge API item + static summaryData
              const mergedItem = { ...summaryData[index], ...item };

              return (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    sx={{
                      background: mergedItem.gradient,
                      color: "#fff",
                      height: 150,
                      borderRadius: 3,
                      boxShadow: 4,
                      cursor: "pointer",
                      // marginTop: "20px",
                      // marginLeft: "15px",
                      transition: "transform 0.2s",
                      "&:hover": { transform: "scale(1.05)" },
                    }}
                  // ✅ mergedItem has query + count
                  >
                    <CardContent
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box
                          onClick={() => handleCardClick(mergedItem)}
                        >
                          <Typography variant="subtitle2" fontWeight="bold">
                            {mergedItem.title}
                          </Typography>
                          <Typography variant="h4" fontWeight="bold">
                            {mergedItem.count}
                          </Typography>
                        </Box>
                        <Avatar
                          sx={{ bgcolor: "white", color: "#000" }}
                        // onClick={() => handleCardClick(mergedItem)}
                        >
                          {mergedItem.icon}
                        </Avatar>
                      </Box>

                      {mergedItem.breakdown && (
                        <Box mt={1}>
                          {mergedItem.breakdown && (
                            <Box mt={1}>
                              {mergedItem.breakdown.map((b, i) => (
                                <Typography
                                  key={i}
                                  ml={0.5}
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    mt: 0.5,
                                    px: 1,
                                    py: 0.3,
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.15)",
                                    borderRadius: 1,
                                    display: "inline-block",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    const prefix = b.split(" ")[0]; // "Self (4)" -> "Self"
                                    const filter =
                                      mergedItem.breakdownFilters[prefix]; // ✅ per-card filter

                                    console.log("Breakdown filter:", filter);
                                    handleBreakdownClick(filter);
                                  }}
                                >
                                  • {b}
                                </Typography>
                              ))}
                            </Box>
                          )}
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
          <Grid container spacing={1} mt={0.5}>
            <Grid item xs={12} md={4}>
              <Card
                sx={{ p: 2, borderRadius: 2, boxShadow: 2, height: "100%" }}
              >
                {dashBoardAttenGetStaus == "fulfilled" && (
                  <Chart
                    options={{
                      chart: {
                        type: "area",
                        stacked: true,
                        height: 220,
                        toolbar: { show: false },
                      },
                      colors: ["#A9A9A9", "#FFD700", "#3f51b5", "#32CD32"], // Match similar color scheme
                      stroke: {
                        curve: "smooth",
                        width: 2,
                      },
                      xaxis: {
                        categories:
                          dashBoardAttenGetData?.projectTaskData?.CumulativeChart?.xaxis,
                      },
                      yaxis: {
                        title: {
                          text: "Number of Tasks",
                          style: {
                            color: "red",
                          },
                        },
                      },
                      tooltip: {
                        x: {
                          formatter: function (val, ope) {
                            const projectMap =
                              dashBoardAttenGetData?.projectTaskData?.CumulativeChart?.Projects || []
                                
                            return projectMap[ope.dataPointIndex] || "Project";
                          },
                        },
                      },
                      legend: {
                        show: false,
                        position: "bottom",
                      },
                      dataLabels: {
                        enabled: false,
                      },
                      title: {
                        text: "Projects Status",
                        align: "center",
                      },
                    }}
                    series={
                      dashBoardAttenGetData?.projectTaskData?.CumulativeChart
                        ?.yaxis
                    }
                    type="area"
                    height={220}
                  />
                )}
              </Card>
            </Grid>

            <Grid item xs={12} md={8}>
              <Card
                sx={{ p: 2, borderRadius: 2, boxShadow: 2, height: "100%" }}
              >
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  Projects Task Effort
                </Typography>

                <Chart
                  type="bar"
                  height={220}
                  options={{
                    chart: {
                      toolbar: { show: false },
                    },
                    xaxis: {
                      categories: dashBoardAttenGetData?.projectTaskData?.xaxis,
                    },
                    tooltip: {
                      x: {
                        formatter: function (val, ope) {
                          const projectMap =
                            dashBoardAttenGetData?.projectTaskData?.Projects ||
                            [];
                          return projectMap[ope.dataPointIndex] || "Project";
                        },
                      },
                    },
                    colors: [
                      "#42a5f5",
                      "#40DB9C",
                      "#FECA04",
                      "#FF9800",
                      "#00695F",
                    ],

                    plotOptions: {
                      bar: {
                        borderRadius: 6,
                        columnWidth: "40%",
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },
                  }}
                  series={dashBoardAttenGetData?.projectTaskData?.yaxis}
                />

              </Card>
            </Grid>
          </Grid>

          {/* <Grid container spacing={1} mt={0.5} wrap="nowrap">         
            <Grid item sx={{ width: "25%" }}>
              <Card sx={{ borderRadius: 2, boxShadow: 2, height: "100%" }}> */}
          <Grid container spacing={1} mt={0.5}>
            {/* LEFT CARD */}
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2, height: "100%" }}>
                <Box
                  height={300}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },

                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                    "& .weekoff-row": {
                      backgroundColor: "#f2acb7", // light red
                      color: "#b71c1c", // dark red text
                    },
                    "& .holiday-row": {
                      backgroundColor: "#c9f5cc", // light green
                      color: "#1b5e20", // dark green text
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    // rows={
                    //   dashBoardAttenGetData.projectTaskData.leaveDetailsData
                    //     .tableData
                    // }
                    rows={tabledatarows}
                    columns={ProjectColumn}
                    onRowClick={(params) => {
                      setSelectedProject(params.row);
                      dispatch(
                        EmployeeEffort({
                          data: {
                            EmployeeID: empID,
                            ProjectID: params.row.P_RECID,
                          },
                        })
                      );
                    }}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={exploreLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    // getRowClassName={(params) =>
                    //   params.indexRelativeToCurrentPage % 2 === 0
                    //     ? "odd-row"
                    //     : "even-row"
                    // }
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2, height: "100%" }}>
                <Box
                  height={300}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },

                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                    "& .weekoff-row": {
                      backgroundColor: "#f2acb7", // light red
                      color: "#b71c1c", // dark red text
                    },
                    "& .holiday-row": {
                      backgroundColor: "#c9f5cc", // light green
                      color: "#1b5e20", // dark green text
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={empEffortGetData}
                    columns={EmployeeColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: EmployeeTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={exploreLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    // getRowClassName={(params) =>
                    //   params.indexRelativeToCurrentPage % 2 === 0
                    //     ? "odd-row"
                    //     : "even-row"
                    // }
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                sx={{ p: 2, borderRadius: 2, boxShadow: 2, height: "100%" }}
              >
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  Project Costing Report
                </Typography>
                {dashBoardAttenGetStaus == "fulfilled" ? (
                  <Chart
                    type="bar"
                    height={220}
                    options={{
                      chart: {
                        toolbar: { show: false },
                      },
                      xaxis: {
                        categories:
                          dashBoardAttenGetData?.taskWeekMonthData?.xaxis || [],
                      },
                      tooltip: {
                        x: {
                          formatter: function (val, ope) {
                            const projectMap =
                              dashBoardAttenGetData?.taskWeekMonthData?.Projects || [];
                            return projectMap[ope.dataPointIndex] || "Project";
                          },
                        },
                      },
                      colors: ["#5EB2F6", "#FF9800", "#FECA04"],
                      plotOptions: {
                        bar: {
                          borderRadius: 6,
                          columnWidth: "40%",
                        },
                      },
                      dataLabels: {
                        enabled: false,
                      },
                    }}
                    series={dashBoardAttenGetData?.taskWeekMonthData?.yaxis}
                  />
                ) : (
                  false
                )}
              </Card>
            </Grid>
          </Grid>
        </React.Fragment>
      ) : (
        false
      )}

      {isCalender ? (
        <Paper
          elevation={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            mt: 2,
            p: 2,
          }}
        >
          {/* <Box
            display="flex"
            justifyContent="end"
            alignItems="center"
            width="100%"
            px={2}
            mb={1}
          > */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            px={2}
            mb={1}
          >
            {/* 🔹 Legends */}
            <Box display="flex" alignItems="center" gap={2}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    // backgroundColor: "#a7f0f3",
                    backgroundColor: "#b9ecee",
                    borderRadius: "3px",
                  }}
                />
                <span style={{ fontSize: "13px" }}>Holiday</span>
              </Box>

              <Box display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    // backgroundColor: "#ee7b8c96",
                    backgroundColor: "#f3bac296",
                    borderRadius: "3px",
                  }}
                />
                <span style={{ fontSize: "13px" }}>Week Off</span>
              </Box>

              <Box display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    // backgroundColor: "#f3cd9b",
                    backgroundColor: "#ddcab1",
                    borderRadius: "3px",
                  }}
                />
                <span style={{ fontSize: "13px" }}>Leave</span>
              </Box>
            </Box>
            {isManager === "1" && (
              <Employeeautocomplete
                sx={{ width: 250 }}
                name="empName"
                label="Personnel"
                id="empName"
                value={selectedEmp}
                onChange={(newValue) => {
                  console.log(newValue, "--find newValue");

                  if (newValue) {
                    setSelectedEmp(newValue);
                    const selectedEmpID = newValue.RecordID;

                    dispatch(
                      DashcalpostData({
                        Year: "2026",
                        Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                        EmployeeID: selectedEmpID,
                      })
                    );
                  } else {
                    setSelectedEmp(null);
                    dispatch(
                      DashcalpostData({
                        Year: "2026",
                        Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                        EmployeeID: empID,
                        // EmployeeID: selectedEmpID,
                      })
                    );
                  }
                }}
                url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${empID}","Any":"","CompId":${compID}}}`}
              />
            )}
          </Box>
          <Datavisual1 />
        </Paper>
      ) : (
        false
      )}
    </Box>
  );
};

export default ManagerDashBoardScrum;
